import type { ApplicationGetApplicationQuery } from '@gql/graphql';
import { DogBreederApplicationStatus } from '@gql/graphql';
import type { MtApplicationsOwnModalFormValues } from '@presentation/components';
import dayjs from 'dayjs';
import { useCallback } from 'react';

export const DEFAULT_OWN_APPLICATION_INITAL_VALUES: MtApplicationsOwnModalFormValues = {
  action: 'own',
  birthday: undefined,
  breed: undefined,
  gender: undefined,
  name: undefined,
};

export const useApplicationInitialValuesBuilder = () => {
  const applicationInitialValuesBuilder = useCallback(
    (
      application?: ApplicationGetApplicationQuery['findUniqueApplication'],
    ): MtApplicationsOwnModalFormValues => {
      if (application?.status === DogBreederApplicationStatus.WAITING_LIST) {
        return {
          action: 'own',
          birthday: application.animal?.birthday ? dayjs(application.animal?.birthday) : undefined,
          breed: application.animal?.dogInfos?.dogBreedId
            ? application.animal.dogInfos.dogBreedId
            : undefined,
          name: application.animal?.name ?? undefined,
          gender: application.animal?.gender ?? undefined,
        };
      }
      return DEFAULT_OWN_APPLICATION_INITAL_VALUES;
    },
    [],
  );

  return { applicationInitialValuesBuilder };
};
